<template>
    <header class="header-global">
        <base-nav class="navbar-main" transparent type="" effect="light" expand 
        v-bind:class="{
            classA: scrollPosition < 100,             
            classB: scrollPosition >= 100
            }">
            <a slot="brand" class="navbar-brand mr-lg-5" href="/" style=" margin-top: -6px;">
                <img src="img/brand/logo-white.png">
            </a>
            <div class="row" slot="content-header" slot-scope="{closeMenu}">
                <div class="col-6 collapse-brand">
                    <a href="/" >
                        <img src="img/brand/logo-v1.png">
                    </a>
                </div>
                <div class="col-6 collapse-close">
                    <close-button @click="closeMenu"></close-button>
                </div>
            </div>

            <ul class="navbar-nav navbar-nav-hover align-items-lg-center">
                <!-- <base-dropdown class="nav-item" menu-classes="dropdown-menu-xl">
                    <a slot="title" href="#" class="nav-link" data-toggle="dropdown" role="button">
                        <i class="ni ni-ui-04 d-lg-none"></i>
                        <span class="nav-link-inner--text">Giới Thiệu</span>
                    </a>
                    <div class="dropdown-menu-inner">
                        <a href="#"
                           class="media d-flex align-items-center">
                            <div class="icon icon-shape bg-gradient-primary rounded-circle text-white">
                                <i class="ni ni-spaceship"></i>
                            </div>
                            <div class="media-body ml-3">
                                <h6 class="heading text-primary mb-md-1">Getting started</h6>
                                <p class="description d-none d-md-inline-block mb-0">Get started with Bootstrap, the
                                    world's most popular framework for building responsive sites.</p>
                            </div>
                        </a>
                        <a href="#"
                           class="media d-flex align-items-center">
                            <div class="icon icon-shape bg-gradient-warning rounded-circle text-white">
                                <i class="ni ni-ui-04"></i>
                            </div>
                            <div class="media-body ml-3">
                                <h5 class="heading text-warning mb-md-1">Components</h5>
                                <p class="description d-none d-md-inline-block mb-0">Learn how to use Argon
                                    compiling Scss, change brand colors and more.</p>
                            </div>
                        </a>
                    </div>
                </base-dropdown> -->
                <ul class="navbar-nav align-items-lg-center ml-lg-auto">
                    <li class="nav-item">
                        <a class="nav-link" href="#/gioi-thieu"
                        data-toggle="tooltip" title="Giới thiệu">
                            <span>Giới thiệu</span>
                        </a>
                    </li>
                    <!--
                    <li class="nav-item">
                        <a class="nav-link" href="#/profile"
                        data-toggle="tooltip" title="Dịch vụ">
                            <span>Dịch vụ</span>
                        </a>
                    </li>
                    -->
                    <base-dropdown tag="li" class="nav-item">
                        <a slot="title" href="#" class="nav-link" data-toggle="dropdown" role="button">
                            <span >Tin Tức</span>
                        </a>
                        <router-link to="/tin-tuc" class="dropdown-item">Khuyến mãi</router-link>
                        <router-link to="/tuyen-dung" class="dropdown-item">Tuyển dụng</router-link>
                    </base-dropdown>

                    <!--
                    <li class="nav-item">
                        <a class="nav-link" href="#/login"
                        data-toggle="dropdown" title="Tin tức">
                            <span>Tin tức</span>
                        </a>
                        <router-link to="/landing" class="dropdown-item">Khuyến mãi</router-link>
                        <router-link to="/profile" class="dropdown-item">Tuyển dụng</router-link>
                    </li>
                    -->
                    <li class="nav-item">
                        <a class="nav-link" href="#/tro-giup"
                        data-toggle="tooltip" title="Trợ giúp">
                            <span>Trợ giúp</span>
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link display_mh display_button" href="https://octa.vn/dang-nhap"
                        data-toggle="tooltip" title="Đăng nhập">
                            <span>Đăng nhập</span>
                        </a>
                    </li>
                    
                </ul>

                
                <!-- <base-dropdown tag="li" class="nav-item">
                    <a slot="title" href="#" class="nav-link" data-toggle="dropdown" role="button">
                        <i class="ni ni-collection d-lg-none"></i>
                        <span class="nav-link-inner--text">Dịch vụ</span>
                    </a>
                    <router-link to="/landing" class="dropdown-item">Giới thiệu</router-link>
                    <router-link to="/profile" class="dropdown-item">Dịch vụ</router-link>
                    <router-link to="/login" class="dropdown-item">Tin tức</router-link>
                    <router-link to="/register" class="dropdown-item">Trợ giúp</router-link>
                </base-dropdown>
                <base-dropdown tag="li" class="nav-item">
                    <a slot="title" href="#" class="nav-link" data-toggle="dropdown" role="button">
                        <i class="ni ni-collection d-lg-none"></i>
                        <span class="nav-link-inner--text">Tin Tức</span>
                    </a>
        
                </base-dropdown> -->
                <!-- <base-dropdown tag="li" class="nav-item">
                    <a slot="title" href="#" class="nav-link" data-toggle="dropdown" role="button">
                        <i class="ni ni-collection d-lg-none"></i>
                        <span class="nav-link-inner--text">Trợ giúp</span>
                    </a>
                </base-dropdown> -->
            </ul>
           
            <ul class="navbar-nav align-items-lg-center ml-lg-auto"></ul>

             <!--
                
                <li class="nav-item">
                    <a class="nav-link nav-link-icon" href="https://www.facebook.com/creativetim" target="_blank"
                       data-toggle="tooltip" title="Like us on Facebook">
                        <i class="fa fa-facebook-square"></i>
                        <span class="nav-link-inner--text d-lg-none">Facebook</span>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link nav-link-icon" href="https://www.instagram.com/creativetimofficial"
                       target="_blank" data-toggle="tooltip" title="Follow us on Instagram">
                        <i class="fa fa-instagram"></i>
                        <span class="nav-link-inner--text d-lg-none">Instagram</span>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link nav-link-icon" href="https://twitter.com/creativetim" target="_blank"
                       data-toggle="tooltip" title="Follow us on Twitter">
                        <i class="fa fa-twitter-square"></i>
                        <span class="nav-link-inner--text d-lg-none">Twitter</span>
                    </a> 
                </li>
                <li class="nav-item">
                    <a class="nav-link nav-link-icon" href="https://github.com/creativetimofficial/vue-argon-design-system"
                       target="_blank" data-toggle="tooltip" title="Star us on Github">
                        <i class="fa fa-github"></i>
                        <span class="nav-link-inner--text d-lg-none">Github</span>
                    </a>
                </li>
                -->

                <li class="nav-item d-none d-lg-block ml-lg-4" style = "color: white;">
                    <span class="nav-link-inner--text">Hotline: (+84) 2435 567 567</span>
                </li>

                <li class="nav-item d-none d-lg-block ml-lg-4">
                    <a href="https://octa.vn/dang-nhap"
                       class="btn btn-neutral btn-icon">
                        <span class="nav-link-inner--text button_login_menu">Đăng nhập</span>
                    </a>
                </li>
           
        </base-nav>
    </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";

export default {
    components: {
        BaseNav,
        CloseButton,
        BaseDropdown
    },
    data(){
        return{
            scrollPosition: null
        }
    },

    methods: {
        updateScroll() {
            this.scrollPosition = window.scrollY
        }
    },

    mounted() {
        window.addEventListener('scroll', this.updateScroll);
    }
};
  
</script>
<style scoped>
    .button_login_menu{
        color: #13b078;
    }
    .display_mh{
        display:none;
    }
    @media (max-width: 768px){
        .display_button{
            display:block;
        }
    }

    .classB{
        position: fixed;
        top: 0;
        background-color: #00a664 !important;
    }
</style>
